import { Stack } from '@mui/material';

import { Order } from '@barboxx/models';

import { FaceVerificationCard } from './FaceVerificationCard';
import { OrderItemsTable } from './OrderItemsTable';
import { OrderTransactionsCard } from './OrderTransactionsCard';
import { PickupDetailsCard } from './PickupDetailsCard';
import { TabDetailsCard } from './TabDetailsCard';

export interface OrderDetailsCardProps {
    order: Order.DetailsResponse;
    imageUrls?: Order.ImageUrlsResponse;
    imageUrlsLoading?: boolean;
    pickupDetailsExpanded: boolean;
    onPickupDetailsExpandedChange: (expanded: boolean) => void;
    faceVerificationExpanded: boolean;
    onFaceVerificationExpandedChange: (expanded: boolean) => void;
}

export function OrderDetailsCard({
    order,
    imageUrls,
    imageUrlsLoading = false,
    pickupDetailsExpanded,
    onPickupDetailsExpandedChange,
    faceVerificationExpanded,
    onFaceVerificationExpandedChange,
}: OrderDetailsCardProps) {
    return (
        <Stack gap={2} sx={{ paddingBottom: 4 }}>
            <TabDetailsCard order={order} />

            <OrderTransactionsCard order={order} />

            <OrderItemsTable orderItems={order.items} />

            <PickupDetailsCard
                order={order}
                imageUrls={imageUrls}
                imageUrlsLoading={imageUrlsLoading}
                pickupDetailsExpanded={pickupDetailsExpanded}
                onPickupDetailsExpandedChange={onPickupDetailsExpandedChange}
            />

            <FaceVerificationCard
                order={order}
                imageUrls={imageUrls}
                imageUrlsLoading={imageUrlsLoading}
                faceVerificationExpanded={faceVerificationExpanded}
                onFaceVerificationExpandedChange={
                    onFaceVerificationExpandedChange
                }
            />
        </Stack>
    );
}
